import Fancybox from "./fancybox.js";
import LazyLoad from 'react-lazyload';

export function Booklet(props) {
  return (
    <li className="list-booklets__list-item">
      <Fancybox>
        <a className="list-booklets__item-link" data-fancybox={Math.random()} href={process.env.PUBLIC_URL + `/videos/` + props.video} role="button">
          <LazyLoad height={120} className="list-booklets__thumbnail">
            <img src={process.env.PUBLIC_URL + `/images/thumbnails/` + props.image} width="120" height="120" alt="" />
          </LazyLoad>
          <div className="list-booklets__content">
            <h3 dangerouslySetInnerHTML={{__html: props.title}}></h3>
            <ul className="list-booklets__levels">
              { props.levels.map((level, idx) =>
                <li key={idx}><span className={`badge badge--` + level.toLowerCase().replace(/ /g, '')}>{level}</span></li>
              )}
            </ul>
          </div>
        </a>
      </Fancybox>
    </li>
  );
}
